"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Extension =
/*#__PURE__*/
function () {
  function Extension() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Extension);

    this.options = Object.assign(Object.assign({}, this.defaultOptions), options);
  }

  _createClass(Extension, [{
    key: "bindEditor",
    value: function bindEditor(editor) {
      this.editor = editor;
    }
  }, {
    key: "keys",
    value: function keys(options) {
      return {};
    }
  }, {
    key: "inputRules",
    value: function inputRules(options) {
      return [];
    }
  }, {
    key: "commands",
    value: function commands(options) {
      return function (attrs) {
        return function () {
          return false;
        };
      };
    }
  }, {
    key: "type",
    get: function get() {
      return "extension";
    }
  }, {
    key: "name",
    get: function get() {
      return "";
    }
  }, {
    key: "plugins",
    get: function get() {
      return [];
    }
  }, {
    key: "rulePlugins",
    get: function get() {
      return [];
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {};
    }
  }]);

  return Extension;
}();

exports.default = Extension;